module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_000.png
// module id = 2316
// module chunks = 5